// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dropdown {
  position: relative;
  display: inline-block; }
  .dropdown .dropdown-toggle {
    background-color: transparent;
    color: #fff;
    border: 1px solid #dadce0;
    color: black;
    padding: 10px;
    cursor: pointer;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-direction: row-reverse;
    gap: 1rem;
    font-size: 1.4rem;
    font-weight: 400;
    color: #4d5156; }
    .dropdown .dropdown-toggle .icon {
      margin-right: 5px; }
  .dropdown .dropdown-menu {
    position: absolute;
    width: 75%;
    top: 100%;
    left: 0;
    background: #fff;
    border: 1px solid #dadce0;
    border-radius: 0.2rem;
    padding-left: 0;
    list-style: none;
    margin: 0;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    z-index: 1;
    display: none;
    opacity: 0;
    transform: scaleY(0);
    transform-origin: top;
    min-width: 18.5rem;
    margin-top: 0.8rem; }
    .dropdown .dropdown-menu li {
      font-size: 1.2rem;
      color: #202124;
      padding: 9px 10px 9px 24px;
      font-size: 1.4rem; }
      .dropdown .dropdown-menu li:hover {
        background-color: #f8f9fa; }
      .dropdown .dropdown-menu li i {
        margin-right: 10px; }
      .dropdown .dropdown-menu li:hover {
        background: #f0f0f0; }
  .dropdown.open .dropdown-menu {
    display: block;
    opacity: 1;
    transform: scaleY(1);
    transition: opacity 0.3s ease, transform 0.3s ease; }
`, "",{"version":3,"sources":["webpack://./src/components/CustomDropdown/CustomDropdown.scss"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,qBAAqB,EAAA;EAFvB;IAKI,6BAA6B;IAC7B,WAAW;IACX,yBAAyB;IACzB,YAAY;IACZ,aAAa;IACb,eAAe;IACf,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,2BAA2B;IAC3B,SAAS;IACT,iBAAiB;IACjB,gBAAgB;IAChB,cAAc,EAAA;IAnBlB;MAsBM,iBAAiB,EAAA;EAtBvB;IA2BI,kBAAkB;IAClB,UAAU;IACV,SAAS;IACT,OAAO;IACP,gBAAgB;IAChB,yBAAyB;IACzB,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,SAAS;IACT,wCAAwC;IACxC,UAAU;IACV,aAAa;IACb,UAAU;IACV,oBAAoB;IACpB,qBAAqB;IACrB,kBAAkB;IAClB,kBAAkB,EAAA;IA5CtB;MA+CM,iBAAiB;MACjB,cAAc;MACd,0BAA0B;MAC1B,iBAAiB,EAAA;MAlDvB;QAoDQ,yBAAyB,EAAA;MApDjC;QAuDQ,kBAAkB,EAAA;MAvD1B;QA2DQ,mBAAmB,EAAA;EA3D3B;IAiEI,cAAc;IACd,UAAU;IACV,oBAAoB;IACpB,kDAAkD,EAAA","sourcesContent":[".dropdown {\n  position: relative;\n  display: inline-block;\n\n  .dropdown-toggle {\n    background-color: transparent;\n    color: #fff;\n    border: 1px solid #dadce0;\n    color: black;\n    padding: 10px;\n    cursor: pointer;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    flex-direction: row-reverse;\n    gap: 1rem;\n    font-size: 1.4rem;\n    font-weight: 400;\n    color: #4d5156;\n\n    .icon {\n      margin-right: 5px;\n    }\n  }\n\n  .dropdown-menu {\n    position: absolute;\n    width: 75%;\n    top: 100%;\n    left: 0;\n    background: #fff;\n    border: 1px solid #dadce0;\n    border-radius: 0.2rem;\n    padding-left: 0;\n    list-style: none;\n    margin: 0;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    z-index: 1;\n    display: none;\n    opacity: 0; // Initially, set opacity to 0\n    transform: scaleY(0); // Initially, set scaleY to 0\n    transform-origin: top;\n    min-width: 18.5rem;\n    margin-top: 0.8rem;\n\n    li {\n      font-size: 1.2rem;\n      color: #202124;\n      padding: 9px 10px 9px 24px;\n      font-size: 1.4rem;\n      &:hover {\n        background-color: #f8f9fa;\n      }\n      i {\n        margin-right: 10px;\n      }\n\n      &:hover {\n        background: #f0f0f0;\n      }\n    }\n  }\n\n  &.open .dropdown-menu {\n    display: block;\n    opacity: 1;\n    transform: scaleY(1);\n    transition: opacity 0.3s ease, transform 0.3s ease; // Add transition properties\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
